class Monitoring.Views.WhitelistView extends Backbone.View

  template: JST["backbone/templates/monitoring/topic_admin/white_list"]

  initialize: (@options = {}) ->
    @labels = @options.labels
    @currentKeywords = @options.currentKeywords

  render: =>
    @keywordView = @_getCustomKeywordView()
    @$el.html(
      @keywordView.render().el
    );
    return this

  _getCustomKeywordView: ->
    whiteKeywords = new Monitoring.Collections.KeywordsCollection()
    whiteKeywords.reset(@currentKeywords)
    keywordView = new Monitoring.Views.KeywordView(
      keywords: whiteKeywords
      entityName: 'keepcon_source',
      attributeName: @options.attributeName or 'white_keyword_ids'
      title: @options.title or 'White List'
      subtitle: '(Include content that contains any of the following keywords)'
      keywordClass: 'label-inverse'
      keywordId: 'whitelist-cbo'
      allowedKeywords: @labels.getKeywords()
      customErrorMessage: @options.customErrorMessage
      afterRender: (container) =>
        container.find('#whitelist-cbo').typeahead(
          source: @_getKeywordsName()
        );
      addedKeywordsTemplate: @template
    )

    return keywordView

  _getKeywordsName: ->
    _.map @labels.getKeywords(), (k) -> k.name

  getKeywordCount: ->
    return @keywordView.getKeywordCount()

  hasInvalidKeywords: (validator) ->
    return _.any @keywordView.keywords.models, (model) ->
      validator(model)